import styled from "styled-components"

export const Wrapper = styled.section`
  transition: background 0.2s ease-in-out;
  background-color: ${props => props.theme.color.mediumBg};
`

export const FlavorRow = styled.div`
  position: relative;
  z-index: 20;

  padding-top: 2rem;
  min-height: 540px;

  @media (max-width: 768px) {
    min-height: 460px;
  }
  @media (max-width: 540px) {
    min-height: 400px;
  }
`

export const SlideButton = styled.button`
  position: absolute;
  left: 50%;
  top: 50%;

  display: block;
  width: 6rem;
  height: 6rem;

  border-radius: 6rem;

  cursor: pointer;
  background-color: rgba(255, 255, 255, 0.4);
  border: none;
  transition: all 0.2s ease-in-out;

  &:hover {
    background-color: rgba(255, 255, 255, 0.8);
  }

  &:disabled {
    opacity: 0;
    cursor: default;
  }

  @media (max-width: 600px) {
    width: 4rem;
    height: 4rem;
  }

  svg {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translateX(-50%) translateY(-50%);

    display: block;
    width: 4rem;
    height: 4rem;

    @media (max-width: 600px) {
      width: 3rem;
      height: 3rem;
    }
  }
`
export const PrevButton = styled(SlideButton)`
  transform: translateX(calc(-240px - 3rem)) translateY(-50%);

  @media (max-width: 768px) {
    left: 1rem;
    transform: translateY(-50%);
  }

  svg {
    transform: translateX(-50%) translateY(calc(-50% + 4px)) rotate(180deg);
  }
`
export const NextButton = styled(SlideButton)`
  transform: translateX(calc(240px - 3rem)) translateY(-50%);

  @media (max-width: 768px) {
    left: initial;
    right: 1rem;
    transform: translateY(-50%);
  }
`

export const FlavorSlide = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translateX(-50%) translateY(-50%) scale(0.8);

  display: flex;
  flex-direction: column;
  width: 320px;

  opacity: 0;
  transition: opacity 0.2s ease-in-out, transform 0.2s ease-in-out;

  @media (max-width: 768px) {
    width: 260px;
  }
  @media (max-width: 540px) {
    width: 180px;
  }

  &[data-active="true"] {
    transform: translateX(-50%) translateY(-50%) scale(1);

    opacity: 1;

    transition-delay: 0.1s;
  }

  .gatsby-image-wrapper {
    /* transform-origin: center 85%; */
    /* transform: scale(0.5); */
    /* transition: transform 0.2s ease-in-out; */

    /* max-width: 100%; */
    /* height: auto; */

    img {
      display: block;
      margin: 0;
    }
  }

  .flavor-label {
    display: flex;
    flex-grow: 1;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;

    padding-top: 1rem;
    opacity: 1;
    transition: opacity 0.1s ease-in-out;

    text-align: center;
    white-space: nowrap;

    h2 {
      margin: 0;
      transition: all 0.2s ease-in-out;
    }

    a {
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0;

      font-style: italic;
      text-align: center;
      color: ${props => props.theme.color.primary};

      transition: all 0.2s ease-in-out;

      svg {
        display: block;
        margin-left: 0.25rem;
      }
    }
  }

  &.swiper-slide-active {
    border-color: lime;

    .gatsby-image-wrapper {
      transform: scale(1);
    }

    .flavor-label {
      opacity: 1;
    }
  }

  .arrow-right {
    fill: ${props => props.theme.color.primary};
    transition: fill 0.2s ease-in-out;
  }
`

export const ThumbRow = styled.div`
  position: relative;
  z-index: 30;

  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  padding: 1rem 2rem 0;
`

export const ThumbSlide = styled.div`
  margin: 0;
  width: 4rem;
  height: 4rem;

  cursor: pointer;

  @media (max-width: 768px) {
    width: 3rem;
    height: 3rem;
  }

  svg {
    transition: all 0.2s ease-in-out;
  }

  &.swiper-slide-active {
    svg {
      transform: scale(1.2);
    }
  }
`
